module.exports = __webpack_public_path__ + "static/media/star-icon-dark-excl.291fb6d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/star-icon-dark-excl.svg
// module id = ./src/assets/images/star-icon-dark-excl.svg
// module chunks = 0